angular.module('access.Nodes')
    .directive('accEmailEsignatureLink', [function () {
        return {
            scope: {
                esignature: '<'
            },
            replace: true,
            template: '<a href ng-click="emailLink()">\
            <span class="wrapper-icon"><i class="icon-acc-invite"></i></span>\
            <span class="wrapper-text">\
                {{ \'signed_files_page_actions_email_link\' | translate }}\
            </span>\
        </a>',
            controller: [
                '$scope',
                '$translate',
                'nodeModalAction',
                function ($scope, $translate, nodeModalAction) {
                    $scope.emailLink = function () {
                        $scope.node = $scope.esignature.mainItem;
                        $scope.node.esignature_uuid = $scope.esignature.uuid;

                        nodeModalAction($scope, {
                            modalController: 'EmailLinkController',
                            modalType: 'confirm',
                            modalAction: 'email_link',
                            modalBodyTemplate: 'nodes/email_link',
                            modalTitle: $translate.instant('Email link to %{node_name}', { node_name: $scope.node.name }),
                            modalSubTitle: $translate.instant('Revision') + ' ' + $scope.esignature.node_revision,
                            modalNotifications: true,
                            reloadCurrent: true
                        }).finally(function () {
                            $scope.$emit('reload.document', $scope.esignature.mainItem);
                        });
                    };
                }]
        }
    }]);
